const Swiper = require('swiper/bundle').default;

/**
 * Rapier-style continuous logo strip (Swiper freeMode + linear autoplay).
 * `data-scroll-speed` = ACF scroll duration in seconds (mapped to transition speed in ms).
 */
module.exports = function initLogoCarousel() {
	if ( typeof window.matchMedia === 'function' && window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		document.querySelectorAll( '.logo-carousel' ).forEach( ( section ) => {
			section.classList.add( 'logo-carousel--reduced' );
		} );
		return;
	}

	document.querySelectorAll( '.logo-carousel__swiper' ).forEach( ( container ) => {
		const raw = container.getAttribute( 'data-scroll-speed' );
		const sec = raw ? parseInt( raw, 10 ) : 40;
		const transitionMs = Number.isFinite( sec ) && sec > 0
			? Math.min( 12000, Math.max( 2000, Math.round( sec * 125 ) ) )
			: 5000;

		new Swiper( container, {
			loop: true,
			loopAdditionalSlides: 4,
			speed: transitionMs,
			freeMode: {
				enabled: true,
				momentum: false,
			},
			// 'auto' + slide min-width: enough logos stay off-screen on wide viewports
			slidesPerView: 'auto',
			spaceBetween: 30,
			watchOverflow: false,
			autoplay: {
				delay: 0,
				disableOnInteraction: false,
				pauseOnMouseEnter: false,
			},
			breakpoints: {
				0: {
					spaceBetween: 20,
				},
				640: {
					spaceBetween: 24,
				},
				1024: {
					spaceBetween: 30,
				},
			},
		} );
	} );
};
